import { common } from './common';
import { auth } from './auth';
import { components } from './components';
import { pages } from './pages';

export const en = {
  common,
  auth,
  components,
  pages,
};
